import React, {Component, useState} from 'react'
import { Button, Table } from 'reactstrap';
import {Link} from 'react-router-dom'
import { withTranslation, Trans } from "react-i18next";
import {PlusCircle, MinusCircle} from 'react-feather'
class StdTable extends Component{

    constructor(props) {
	super(props);
    }
    
    
    render(){	
	const {collection, fields, collection_key, actions, actions_props, trans_prefix,t, childs, backgroundColor } = this.props

	const text_format = (element, f) => {
	    if(typeof(f) === 'string')
		return element[f]
	    else{
		return <Trans values={{ value: element[f.name]}} >standard_formatting.{f.type}</Trans>
	    }
	    
	}

	
	const StdTableRow = (props) =>  {
	    const [showChilds, setShowChilds] = useState(false);
	    return(
		<React.Fragment>
		<tr style={{backgroundColor: typeof backgroundColor === "function" ? backgroundColor(props.element) : null}}>
		
		{fields.map((f) => <td key={typeof(f) === 'string' ? f : f.name}>{text_format(props.element, f)}</td>)}
		{<React.Fragment>
		    {actions.length > 0 &&
		     (<td className="actions_col">{actions.map((Action, index) => <Action initialValues={props.element} key={index} {...actions_props.reduce(function(map, obj) {
			     map[obj] = props[obj];
			     return map;
			 }, {})}/> )}</td>)}
		    {childs != null &&  Array.isArray(props.element[childs]) && <td>{props.element[childs].length}
			<button className="content_button" onClick={() =>  setShowChilds(!showChilds) }>{showChilds ? <MinusCircle /> : <PlusCircle />}</button>
		</td>}
		</React.Fragment>
		}
		</tr>
		{childs != null && Array.isArray(props.element[childs]) && props.element[childs].map(i => <tr style={{display: showChilds ? 'table-row' : 'none', backgroundColor: typeof backgroundColor === "function" ? backgroundColor(props.element) : null}} key={i.id}>{fields.map((f) => <td key={typeof(f) === 'string' ? f : f.name}>{text_format(i, f)}</td>)}
		    {
			actions.length > 0 &&
			(<td className="actions_col">{actions.map((Action, index) => <Action initialValues={i} key={index} {...actions_props.reduce(function(map, obj) {
				map[obj] = props[obj];
				return map;
			    }, {})}/> )}</td>)
			
			
		    }<td></td></tr>)}
		
		</React.Fragment>
	    )}
	
	return  (collection.length > 0 ? <Table striped className="std-table">
	    <thead>
		<tr>
		    {fields.map((f) => <th key={typeof(f) === 'string' ? f : f.name}>{trans_prefix != null ? <Trans>{trans_prefix}.{typeof(f) === 'string' ? f : f.name}</Trans> : (typeof(f) === 'string' ? f : f.name)}</th>)}
		    {actions.length > 0 && (<th className="actions_col"></th>)}
		</tr>
		
	    </thead>
	    <tbody>
		{collection.map((element) => <StdTableRow key={element[collection_key]} element={element} id={element[collection_key]} />
		    
		)}
	    </tbody>
	</Table>
				   : null)

    }
}

StdTable.defaultProps = {
    collection: [],
    fields: [],
    actions: []
}
export default withTranslation()(StdTable)
